import HearingTestManager from './HearingTestManager'
import HearingTestEvaluation from './HearingTestEvaluation'
import HearingTestConfiguration from './HearingTestConfiguration'
import HearingTestPreparation from './HearingTestPreparation'
import HearingTestNumbers from './HearingTestNumbers'
import HearingTestWords from './HearingTestWords'
// import Instruments from './utils/Sounds'

import configuration from './configuration'

// console.log(Instruments)

class HearingTestHandler {
  constructor (headphoneType, lang) {
    this.hearingTestPreparation = new HearingTestPreparation()
    this.hearingTestNumbers = new HearingTestNumbers(headphoneType, lang)
    this.hearingTestWords = new HearingTestWords(headphoneType, lang)
    this.hearingTestManager = new HearingTestManager(
      new HearingTestConfiguration(configuration, headphoneType),
      new HearingTestEvaluation(),
      lang
    )
  }

  init () {
    try {
      if (!this.hearingTestManager.isPlaying) {
        // this.hearingTestManager.init()
        this.hearingTestManager.init()
      }
    } catch (err) {
      console.log(err)
    }
  }

  handleUserInput () {
    this.hearingTestManager.processUserInput()
  }

  evaluateInstrument (choice) {
    this.hearingTestPreparation.evaluate(choice)
  }

  playTonalInstructions () {
    this.hearingTestManager.playInstructionsLoop()
  }

  stopTonalInstructions () {
    this.hearingTestManager.stopInstructionsLoop()
  }

  evaluateNumber (choice) {
    this.hearingTestNumbers.evaluate(choice)
  }

  initNumbers () {
    this.hearingTestNumbers.init()
  }

  playNumbersInstructions () {
    this.hearingTestNumbers.playInstructionsLoop()
  }

  evaluateWord (choice) {
    this.hearingTestWords.evaluate(choice)
  }

  initWords () {
    this.hearingTestWords.init()
  }

  playWordsInstructions () {
    this.hearingTestWords.playInstructionsLoop()
  }

  initPreparation () {
    this.hearingTestPreparation.init()
  }

  destroy () {
    console.log('destroyed')
  }
}

export default HearingTestHandler